<div style='position: relative;'>
  <app-a-input [(variable)]="search" [icon]='"search"' (onBlur)='timedHide()' (onType)="onType($event)"
    [label]="'Search'"></app-a-input>
  <ion-card *ngIf="showSuggestion" class='margin0 padding10 suggestionBox'>
    <div *ngFor="let item of filteredList" class='wordWrap' (click)='selectSuggestion(item)'>
      <span *ngFor="let criteria of criteriaList">
        {{item[criteria]}}&nbsp;&nbsp;
      </span>
      <hr>
    </div>
  </ion-card>
</div>